import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  side?: 'bottom' | 'right';
  className?: string;
}

export function Sheet({ open, onClose, children, side = 'bottom', className }: Props) {
  const variants =
    side === 'bottom'
      ? { initial: { y: '100%' }, animate: { y: 0 }, exit: { y: '100%' } }
      : { initial: { x: '100%' }, animate: { x: 0 }, exit: { x: '100%' } };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="fixed inset-0 z-40 bg-black/40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className={cn(
              'fixed z-50 bg-bg-elevated shadow-2xl',
              side === 'bottom'
                ? 'inset-x-0 bottom-0 max-h-[90vh] rounded-t-2xl'
                : 'inset-y-0 right-0 w-full max-w-md',
              className
            )}
            {...variants}
            transition={{ type: 'spring', damping: 30, stiffness: 260 }}
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
